<template>
  <div class="user-center__access-record-container user-center__common-child-container">
    <SubPageHeader>
      <template #title>
        <router-link
          tag="div"
          :to="nav.url"
          active-class="active"
          class="title__front-item"
          v-for="(nav, index) in breadcrumbs"
          :key="index"
          >{{ nav.name }}</router-link
        >
      </template>
    </SubPageHeader>
    <div class="access-record__main-body" v-if="lists && lists.length > 0">
      <div class="access-record__item">
            <div class="item__name item__child">项目名称</div>
            <!-- <div class="item__job item__child">类型</div> -->
            <div class="item__job item__child">积分</div>
            <div class="item__date item__child">时间</div>
        </div>
        <div class="access-record__item"
            v-for="list in lists"
            :key="list.id"
        >
            <div class="item__name item__child">{{list.content}}</div>
            <!-- <div class="item__job item__child">{{handleType(list)}}</div> -->
            <div class="item__job item__child">{{list.type == 2 ? "+" : "-"}} {{list.integral}}</div>
            <div class="item__date item__child">{{list.c_time | parseTime}}</div>
        </div>
        <div class="access-record__item">
            <!-- <div class="item__name item__child">当前积分</div>
            <div class="item__job item__child">{{integral}}</div> -->
        </div>
        <div class="access-record__item">
            <div class="item__name item__child">当前剩余积分：</div>
            <div class="item__job item__child"></div>
            <div class="item__job item__child">{{integral}}</div>
        </div>
        <div class="access-record__item">
            <div class="item__name item__child">积分累计充值：</div>
            <div class="item__job item__child"></div>
            <div class="item__job item__child">{{cumulative_integral}}</div>
        </div>
    </div>
    <empty hint="暂无记录" v-else></empty>
    <pagination
      class="component-pagination"
      v-if="showPage"
      :config="paginationConfig"
    ></pagination>
  </div>
</template>

<script>
import Empty from '@/pages/common/empty.vue';
import { scrollToUp } from '@/assets/utils/common';
import { integralDetailed } from '@/api/user';
import Pagination from '@/components/pagination.vue';
import SubPageHeader from '../_pageHeader.vue';

export default {
  components: {
    SubPageHeader,
    Pagination,
    Empty,
  },
  data() {
    return {
      breadcrumbs: [
        {
          name: '积分推广',
          url: '/my/promote',
        },
        {
          name: '积分消耗报告',
          url: '/my/integral',
        },
      ],
      pageSize: 10,
      paginationConfig: {},
      lists: null,
      requesting: false,
      showPage: false,
      typeOpe: [
        //1 查看需求 2主页被查看 3私信  4文章曝光 5案例曝光 6商家曝光 7产品曝光
        //8封面banner 9科普推荐  10通讯录专家推送 11封面海报 12网站背景图 13案例1号位置  14 案例2，3号位置 15案例广告位置 16网站入驻海报位置
        {
          id: 1,
          name: '查看需求'
        },
        {
          id: 2,
          name: '主页被查看'
        },
        {
          id: 3,
          name: '私信'
        },
        {
          id: 4,
          name: '文章曝光'
        },
        {
          id: 5,
          name: '案例曝光'
        },
        {
          id: 6,
          name: '商家曝光'
        },
        {
          id: 7,
          name: '产品曝光'
        },
        {
          id: 8,
          name: '封面banner'
        },
        {
          id: 9,
          name: '科普推荐'
        },
        {
          id: 10,
          name: '通讯录专家推送'
        },
        {
          id: 11,
          name: '封面海报'
        },
        {
          id: 12,
          name: '网站背景图'
        },
        {
          id: 13,
          name: '案例1号位置'
        },
        {
          id: 14,
          name: '案例2，3号位置'
        },
        {
          id: 15,
          name: '案例广告位置'
        },
        {
          id: 16,
          name: '网站入驻海报位置'
        },
        {
          id: 17,
          name: '系统推送'
        },
      ],
      integral: 0,
      cumulative_integral: 0,
    };
  },
  computed: {
    page() {
      return this.$route.query.page || 1;
    },
  },
  watch: {
    $route: {
      handler: 'init',
      immediate: true,
    },
  },
  methods: {
    async init() {
      // 获取数据
      this.$store.commit('openLoading');
      const res = await integralDetailed({
        page: this.page,
        page_size: this.pageSize,
        // detailed_type: 8
      });
      const { data } = res;
      this.lists = data.list;
      this.integral = data.integral
      this.cumulative_integral = data.cumulative_integral
      this.paginationConfig.page_num = data.total && data.total.page_num;
      if(this.paginationConfig.page_num > 0) this.showPage = true
      scrollToUp();
      this.$store.commit('closeLoading');
    },
    handleType(list) {
      //类型 1 查看需求 2主页被查看 3私信  4文章曝光 5案例曝光 6商家曝光 7产品曝光 8封面banner 
      //9科普推荐  10通讯录专家推送 11封面海报 12网站背景图 13案例1号位置  14 案例2，3号位置 15案例广告位置 16网站入驻海报位置
      if(list.type == 2) {
        return "充值"
      }
      return this.typeOpe.find((item) => item.id == list.detailed_type).name
    },
  },
};
</script>

<style scoped>
  .user-center__access-record-container {
    padding-bottom: 20px;
  }
</style>
